PluginButtonView = require 'views/plugin/plugin-button-view'
t = require('views/internal/teacup-with-helpers')()
track = require 'debug/track'
trackUe = require 'debug/trackUe'
colors = require 'data/colors.json'

template = t.renderable ({ icon, text }) ->
  t.a '.button-link', {
    title: text,
    href: '#'
  }, ->
    if icon
      t.span '.icon-sm.plugin-icon',
        style: t.stylify
          'background-image': t.urlify t.addRecolorParam(icon, "?color=#{ colors.iconDefault }")
    t.span text

module.exports = class PluginCardButtonView extends PluginButtonView

  render: ->
    @$el.html(template(@pluginButton))
    @

  trackClick: (pluginButton) ->
    track("Card Detail", "Sidebar Plugin Button", pluginButton.text)
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', pluginButton.idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-button-view.coffee